import { z } from 'zod';

import { LoanId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';

export const BaseLoanIdSideEffect = z.object({
  loanId: zodBrandedUuid<LoanId>(),
});
